module.exports = __webpack_public_path__ + "img/ulysses.7fb48072.png";